<script setup>
import { reactive } from 'vue'
import {
  KkModal,
  KkCheckbox,
  KkButton
} from '../../../../../components/base'
import iconInstagramPath from '../../../../../../../images/sns/icon_instagram.svg'

const emit = defineEmits(['submit', 'close'])
const state = reactive({
  checkIds: []
})
const props = defineProps({
  accounts: { type: Array, required: true },
  openModal: { type: Boolean, default: false }
})
const handleSubmit = () => {
  emit('submit', state.checkIds)
}

const checkAccounts = (appPageIds) => {
  if(state.checkIds.includes(appPageIds)) {
    state.checkIds = state.checkIds.filter(v => v !== appPageIds)
  } else {
    state.checkIds.push(appPageIds)
  }
}

const checkAllAccounts = () => {
  if(state.checkIds.length === props.accounts.length) {
    state.checkIds = []
  } else {
    state.checkIds = props.accounts.map(v => v.appPageIds)
  }
}
</script>
<template>
  <KkModal :is-visible="props.openModal" @change="emit('close')">
    <div class="content__header">
      {{ $t('pages.companies.snsOauth.instagramConnectModal.title') }}
    </div>
    <div class="content__body">
      <KkCheckbox
        id="allCheckModal"
        class="allCheck"
        :model-value="state.checkIds.length === accounts.length"
        :label="$t('pages.companies.snsOauth.instagramConnectModal.allCheck')"
        @change="checkAllAccounts"
      />
      <div v-for="(account, index) in props.accounts" :key="index" class="accountContainer">
        <KkCheckbox
          :id="`modal-${account.id}`"
          :model-value="state.checkIds.includes(account.appPageId)"
          @change="checkAccounts(account.appPageId)"
        />
        <div class="accountContainer__images">
          <img alt="" :src="account.picture.url" class="accountContainer__thumbnail">
          <img alt="" :src="iconInstagramPath" class="accountContainer__icon">
        </div>
        <div class="accountContainer__contents">
          {{ account.name }}
          <div class="accountContainer__accountId">@{{ account.appPageId }}</div>
        </div>
      </div>
    </div>
    <div class="content__footer">
      <div class="c-button">
        <i18n-t keypath="pages.companies.snsOauth.instagramConnectModal.accountsCount" class="account-count-wap">
          <span class="account-count">{{ state.checkIds.length }}</span>
        </i18n-t>
        <div class="buttonItem">
          <KkButton
            color="secondary"
            outlined
            :text="$t('labels.cancel')"
            @click="emit('close')"
          />
        </div>
        <div class="buttonItem">
          <KkButton
            color="primary"
            :disabled="state.checkIds.length === 0"
            :text="$t('pages.companies.snsOauth.instagramConnectModal.connect')"
            @click="handleSubmit"
          />
        </div>
      </div>
    </div>
  </KkModal>
</template>
<style lang="scss" scoped>
@import '../../../../../../../stylesheets/biz_spa/foundation/_var.scss';
.content {
  &__header {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    padding: 20px 32px;
    border-bottom: 1px solid $color-base-c;
    font-size: 16px;
    line-height: 1.5;
  }

  &__footer {
    padding: 32px;
    border-top: 1px solid $color-base-c;
  }

  &__body {
    height: 50vh;
    padding: 32px;
    overflow-y: scroll;
  }

  &__footer {
    display: flex;
    justify-content: flex-end;
  }
}
.accountContainer {
  display: flex;
  align-items: center;
  padding: 18px;
  border: 1px solid #E4E7EB;
  border-radius: 4px;
  margin: 10px 0;
  &__images {
    position: relative;
    margin-right: 30px;
    img{
      border-radius: 50%;
    }
  }
  &__thumbnail {
    width: 50px;
    height: 50px;
    object-fit: cover;
  }
  &__icon {
    position: absolute;
    width: 32px;
    height: 32px;
    bottom: 0;
    left: 60%;
    background: #fff;
    border: solid 3px #fff;
  }
  &__accountId {
    color: #9e9e9e;
  }
}
.allCheck {
  font-weight: bold;
}

.account-count-wap {
  margin-right: 10px;
}
.account-count {
  margin: 0 5px;
  font-size: 30px;
  font-weight: 700;
  color: $color-accent-primary;
}
.buttonItem {
  margin-left: 10px;
}
</style>
